import { Inject, Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { DOCUMENT } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class CookiebotGuard implements CanActivate {
  constructor(@Inject(DOCUMENT) private document: Document) {}

  public canActivate(): boolean {
    if (!this.document.getElementById('Cookiebot')) {
      const script = this.document.createElement('script');

      script.id = 'Cookiebot';

      script.src = 'https://consent.cookiebot.com/uc.js';

      script.async = true;

      script.setAttribute('data-cbid', 'c97d904d-7fe0-44d5-99a0-54bc7f49181b');

      this.document.body.appendChild(script);
    }

    return true;
  }
}
